import { AxiosInstance } from "axios";

// Роуты admin-api на шлюзе отдаются под v3 (в OpenAPI-доке помечены как v1).
class OrdersLogApi {
    api: AxiosInstance;

    constructor(api) {
        this.api = api;
    }

    async list(orderId, { pageNumber, pageSize } = {}) {
        return await this.api.fetch({
            method: "get",
            url: `/admin/orders/${orderId}/logs`,
            urlVersion: 3,
            params: {
                ...(pageNumber ? { page_number: pageNumber } : {}),
                ...(pageSize ? { page_size: pageSize } : {}),
                _: Date.now(), // _ — обход кэша браузера
            },
        });
    }
}

export default OrdersLogApi;
